module.exports = __webpack_public_path__ + "img/Kibe69.4731fe1b.jpg";